// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "trix"
import "@rails/actiontext"

// Turn off drag and drop of file attachments in trix editor
// Allow attachments when trix-editor has data-attachments="true"
document.addEventListener("trix-file-accept", function(event) {
  const editor = event.target.closest("trix-editor");
  if (!editor || editor.dataset.attachments !== "true") {
    event.preventDefault();
  }
});
